import React, { useState, useEffect } from "react";

const AddEmployment = ({ onClose, onSave, initialValues, category, index }) => {
  const [formData, setFormData] = useState({
    role: "",
    company: "",
    startDate: "",
    endDate: "",
    description: "",
  });
  useEffect(() => {
    if (initialValues) {
      setFormData(initialValues);
    }
  }, [initialValues]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose("");
    // Handle form submission logic here
  };
  return (
    <div className=" flex justify-center h-screen  login_inform-inner m-auto p-20 job-page">
      <div className="flex ">
        <div className="form_upto  jobapply-width m-3 loginDiv" id="step_1">
          <div className="bg-white shadow-md rounded px-6 pt-4 pb-6 mb-4">
            <>
              <h1 className="hrp-heading-size text-center hrp-About">
                Add Employment{" "}
              </h1>
              <form
                onSubmit={(e) => handleSubmit(e)}
                className="register-form-section animated-form"
              >
                <div className="form-group">
                  <input
                    type="text"
                    id="role"
                    placeholder=""
                    value={formData.role}
                    onChange={handleChange}
                    className="shadow w-full border rounded py-2 px-3"
                    required
                  />
                  <label htmlFor="role" className="form-input-label">
                    Job Title
                  </label>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="company"
                    placeholder=""
                    value={formData.company}
                    onChange={handleChange}
                    className="shadow w-full border rounded py-2 px-3"
                    required
                  />
                  <label htmlFor="company" className="form-input-label">
                    Company Name
                  </label>
                </div>
                <div className="mb-2 grid md:grid-cols-2 grid-cols-1 gap-x-5">
                  <div className="form-group">
                    <input
                      type="date"
                      id="startDate"
                      placeholder=""
                      value={formData.startDate}
                      onChange={handleChange}
                      className="shadow w-full border rounded py-2 px-3"
                      required
                    />
                    <label htmlFor="startDate" className="form-input-label">
                      Start Date
                    </label>
                  </div>
                  <div className="form-group">
                    <input
                      type="date"
                      id="endDate"
                      placeholder=""
                      value={formData.endDate}
                      onChange={handleChange}
                      className="shadow w-full border rounded py-2 px-3"
                      required
                    />
                    <label htmlFor="endDate" className="form-input-label">
                      End Date
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    type="textarea"
                    id="description"
                    placeholder=""
                    value={formData.description}
                    onChange={handleChange}
                    className="shadow w-full border rounded-full py-2 px-3"
                  />
                  <label htmlFor="description" className="form-input-label">
                    Description
                  </label>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="hrp-find-course-btn py-3 px-10 rounded-full"
                  >
                    Save
                  </button>
                </div>
              </form>
            </>
          </div>
        </div>
        <button
          className="   text-2xl flex mx-auto justify-center items-center bg-white rounded-2xl w-6 h-6 top-6 right-2 close-btn-style"
          onClick={onClose}
        >
          &times;
        </button>
      </div>
    </div>
  );
};
export default AddEmployment;
